/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Styles

// JS
import './facebook_omniauth.js';
import './apple_omniauth.js';

$(document).ready(function(){
    setTimeout(function(){
        $('.notification.is-success').fadeOut()
    }, 3000)
    $("#facebook_sign_in").removeClass('is-block');
    $("#facebook_sign_in").hide();
    $("#v1_user_email").keyup(function() {
        if(this.value.endsWith('@tfbnw.net')){
            $("#facebook_sign_in").addClass('is-block');
            $("#facebook_sign_in").show();
        } else {
            $("#facebook_sign_in").removeClass('is-block');
            $("#facebook_sign_in").hide();
        }
    });
})
